import { defineMessages } from 'react-intl';

export default defineMessages({
    availableDocuments: {
        id: 'ml.gateway.endorsement.common.availableDocuments.Available Documents',
        defaultMessage: 'Available Documents'
    },
    requiredDocuments: {
        id: 'ml.gateway.endorsement.common.availableDocuments.required Documents',
        defaultMessage: 'required documents'
    },
    allDocsSigned: {
        id: 'ml.gateway.endorsement.common.availableDocuments.allDocsSigned',
        defaultMessage: 'All the {requiredDocuments} must be signed in order to proceed'
    },
    followingDocuments: {
        id: 'ml.gateway.endorsement.common.availableDocuments.following documents',
        defaultMessage: 'following documents'
    },
    docsRetained: {
        id: 'ml.gateway.endorsement.common.availableDocuments.docsRetained',
        defaultMessage: 'The {followingDocuments} must be retained for your records.'
    },
    documents: {
        id: 'ml.gateway.endorsement.common.availableDocuments.Documents',
        defaultMessage: 'Documents'
    },
    signatureType: {
        id: 'ml.gateway.endorsement.common.availableDocuments.Signature Type',
        defaultMessage: 'Signature Type'
    },
    dateSigned: {
        id: 'ml.gateway.endorsement.common.availableDocuments.Date Signed',
        defaultMessage: 'Date Signed'
    },
    documentRetention: {
        id: 'ml.gateway.endorsement.common.availableDocuments.Document Retention',
        defaultMessage: 'Document Retention'
    },
    actions: {
        id: 'ml.gateway.endorsement.common.availableDocuments.Actions',
        defaultMessage: 'Actions'
    },
    view: {
        id: 'ml.gateway.endorsement.common.availableDocuments.View',
        defaultMessage: 'View'
    },
    viewEnglish: {
        id: 'ml.gateway.endorsement.common.availableDocuments.View English',
        defaultMessage: 'View English'
    },
    viewSpanish: {
        id: 'ml.gateway.endorsement.common.availableDocuments.View Spanish',
        defaultMessage: 'View Spanish'
    },
    est: {
        id: 'ml.gateway.endorsement.common.availableDocuments.EST',
        defaultMessage: 'EST'
    },
    ut: {
        id: 'ml.gateway.endorsement.common.availableDocuments.UT',
        defaultMessage: 'UT'
    },
    followingdocIssues: {
        id: 'ml.gateway.endorsement.common.followingdocIssues',
        defaultMessage: 'The following underwriting issues have been identified:'
    },
    ineligiblePolicy: {
        id: 'ml.gateway.endorsement.common.ineligiblePolicy',
        defaultMessage: 'Proof required'
    },
    unableToContinueWithPolicy: {
        id: 'ml.gateway.endorsement.common.documentUploadissues.provideInfo',
        defaultMessage: 'Provide requested info to proceed.'
    },
    reason: {
        id: 'ml.gateway.endorsement.common.uwissues.reason',
        defaultMessage: 'Contingency :'
    },
    uploadProof: {
        id: 'ml.gateway.endorsement.common.upload',
        defaultMessage: 'Upload Proof'
    },
    hideAllIssues: {
        id: 'ml.endorsement.common.policyChangeSummary.hideAllIssues',
        defaultMessage: 'Hide all issues'
    },
    showAllIssues: {
        id: 'ml.endorsement.common.policyChangeSummary.showAllIssues',
        defaultMessage: 'Show all issues'
    }
})